import { render, staticRenderFns } from "./Allianceend.vue?vue&type=template&id=76472101&"
import script from "./Allianceend.vue?vue&type=script&lang=js&"
export * from "./Allianceend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports